<script>
//#region DOCUMENTACIÓN

// [...] -> Palabra dentro de [] hace referencia a una variable o referencia textual del código. Al usar Ctrl + F (sin los []) sobre este te saldrán todas las incidencias.
// [!]   -> Información importante favor de leer.
// (*)   -> Notas

// (1) - Este componente funcional transforma todas las celdas de la columna que lo utiliza un elemento input NUMÉRICO de HTML.

// (2) - El valor del input será dado por el prop [inputVlaue], sin embargo este debe tener el nombre de la PROPIEDAD que contiene
//       el valor a mostrar dentro del input.

//   (EXPLICACIÓN) - Los datos de la fila se mandan dentro del [context.data.attrs.row](*) el cual es un objeto con todas las propiedades (o columnas) de la fila.
//   El valor del prop [inputVlaue] debe ser el nombre de la propiedad del [context.data.attrs.row] que contenga el dato que se necesite agregar.

// (3) - El prop [disable] establece si el input esta esta habilidado o no mediante una FUNCIÓN que debe retornar un booleano, siendo TRUE desabilitado y FALSE habilitado.
//   [!] -> Para que se mande el valor de forma dinámica estos deben ser retornados desde un método(**) y en caso de que se quiera mandar un simple booleado usar una función
//          anónima que simplemente retorne el valor(***).

// (4) - [rowGoal] y [rowValue] son simples variables que son usadas para diferenciar si se trata de una META o un VALOR, respectivamente, en el
//       módulo de KPI Gerencial, archivo [KpiDirections.vue].

//   (4.1) -> [!] Siempre y cuando [!]NO[!] se usen las palabras "goal" o "value", se tomará el valor del prop [inputValue] para guardar el input del usuario.

// [!][!][!] ESTE COMPONENTE NO RETORNA EL VALOR MODIFICADO, SINO QUE EDITA DIRECTAMENTE EL VALOR DE LA LINEA DE LA TABLA.   [!][!][!]
// [!][!][!] PARA GUARDAR EL VALOR/VALORES MODIFICADOS SOLO HABRÁ QUE MANDAR UNA PETICIÓN CON LA TABLA/ARREGLO DIRECTAMENTE. [!][!][!]

// (*)   -> para mayor claridad imprima el consola el context.data.attrs.row.
// (**)  -> para mayor claridad busca el método [isGoalDisable] ó [isValueDisable] en el archivo [KpiDirections.vue].
// (***) -> para mayor claridad buscar el formatter [InputColumn] dentro del archivo [CahsFlow.vue]
//#endregion
export default {
  name: "InputColumn",
  functional: true,
  props: {
    inputValue: {
      type: String
    },
    disabled: {
      type: Function
    },
    UpdateInventoryQTY: {
      type: Function
    }
  },

  render(createElement, context) {
    //console.log("context: ", context)
    let newValue = context.data.attrs.rowValue;
    let { column } = context.data.attrs;
    let selectedRow = context.data.attrs.row;
    const rowGoal = Object.keys(context.data.attrs.row)[1];
    const rowValue = Object.keys(context.data.attrs.row)[2];
    let element;

    if (
      context.props.inputValue === "AccountName" &&
      context.data.attrs.column === "AccountName"
    ) {
      //console.log("context inside input: ", context, "\n createElement: ",createElement("el-input"));
      element = createElement("input", {
        attrs: {
          value: newValue,
          class: "el-input__inner"
        },
        on: {
          input: function (event) {
            //console.log("el input event", event.target.value );
            selectedRow[context.props.inputValue] = event.target.value;
          }
        }
      });
    } else if (
      context.props.inputValue === "Comentary" &&
      context.data.attrs.column === "Comentary"
    ) {
      //console.log("context inside input: ", context, "\n createElement: ",createElement("el-input"));
      element = createElement("input", {
        attrs: {
          value: newValue,
          class: "el-input__inner"
        },
        on: {
          input: function (event) {
            //console.log("el input event", event.target.value );
            selectedRow[context.props.inputValue] = event.target.value;
          }
        }
      });
    } else if (context.props.inputValue === "invQTY") {
      //console.log("CreateElement: ", createElement("input"))
      element = createElement("input", {
        attrs: {
          value: newValue,
          class: "el-input__inner"
        },
        on: {
          input: function (event) {
            //console.log("el input event", event.target.value );
            selectedRow[column] = event.target.value;
          },
          blur: function () {
            context.props.UpdateInventoryQTY(newValue, selectedRow, column);
          }
        }
      });
    } else {
      //console.log()
      element = createElement("input", {
        domProps: {
          value:
            context.data.attrs.row[
              context.props.inputValue == "goal"
                ? rowGoal
                : context.props.inputValue == "value"
                ? rowValue
                : context.props.inputValue
            ],
          type: "number",
          disabled: context.props.disabled(),
          className: context.props.disabled()
            ? "el-input__inner  input-disable"
            : "el-input__inner"
        },
        on: {
          change: function (event) {
            if (context.data.attrs.column == "goal") {
              context.data.attrs.row[rowGoal] = Number(event.target.value);
              selectedRow[rowGoal] = Number(event.target.value);
            } else if (context.data.attrs.column == "value") {
              context.data.attrs.row[rowValue] = Number(event.target.value);
              selectedRow[rowValue] = Number(event.target.value);
            } else {
              context.data.attrs.row[context.props.inputValue] = Number(
                event.target.value
              );
              selectedRow[context.props.inputValue] = Number(
                event.target.value
              );
            }
          }
        }
      });
    }

    return element;
  }
};
</script>

<style scoped>
.input-disable {
  background: #f5f7fa;
  color: #d0d4da;
}
</style>
